//Using history to redirect to other pages.
import axios from "axios"

const URL = '  https://food-mafia-server.herokuapp.com/api/';

export const verifyUserCredentials = (user) => {
    fetch(URL + "login", {
        method: 'POST',
        body: JSON.stringify(user),
        headers: {
            'content-type': 'application/json'
        }
    }).then(res => {
        if(res.status === 200){
            //alert("login successful");
            window.location.href='/home'
        }
        else{
            alert("Please enter the valid username password")
            window.location.href = '/login'
        }
    });
}

export const checkLoggedIn = () => {
    fetch(URL + "checkLogin").
    then(response => {
            console.log(response.json())
            return response.json()
    });
}

export const Logout = () => {
    console.log("React logout portion!!")
    fetch(URL + "logout", {
        method: 'POST',
        headers: {
            'content-type': 'application/json'
        }
    }).then(response => response.json());
}

//Refactored the axios part here. Use this to check for login auth.
export const axiosLogin = () => 
    axios.get('  https://food-mafia-server.herokuapp.com/api/checkLogin')
